webpackJsonp([241083611932213],{

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ArvindThakur = __webpack_require__(99);
	
	var _ArvindThakur2 = _interopRequireDefault(_ArvindThakur);
	
	var _Deepak_Kapoor_new = __webpack_require__(100);
	
	var _Deepak_Kapoor_new2 = _interopRequireDefault(_Deepak_Kapoor_new);
	
	var _LalitaGupte = __webpack_require__(101);
	
	var _LalitaGupte2 = _interopRequireDefault(_LalitaGupte);
	
	var _ManishaGirotra = __webpack_require__(102);
	
	var _ManishaGirotra2 = _interopRequireDefault(_ManishaGirotra);
	
	var _padmajaRuparel = __webpack_require__(108);
	
	var _padmajaRuparel2 = _interopRequireDefault(_padmajaRuparel);
	
	var _persistentRoshiniBakshi = __webpack_require__(110);
	
	var _persistentRoshiniBakshi2 = _interopRequireDefault(_persistentRoshiniBakshi);
	
	var _Soumya_Rajan_new = __webpack_require__(148);
	
	var _Soumya_Rajan_new2 = _interopRequireDefault(_Soumya_Rajan_new);
	
	var _sujoyBose = __webpack_require__(111);
	
	var _sujoyBose2 = _interopRequireDefault(_sujoyBose);
	
	var _VT = __webpack_require__(105);
	
	var _VT2 = _interopRequireDefault(_VT);
	
	var _geeta = __webpack_require__(106);
	
	var _geeta2 = _interopRequireDefault(_geeta);
	
	var _neelam = __webpack_require__(107);
	
	var _neelam2 = _interopRequireDefault(_neelam);
	
	var _nithya = __webpack_require__(150);
	
	var _nithya2 = _interopRequireDefault(_nithya);
	
	var _pallavi = __webpack_require__(109);
	
	var _pallavi2 = _interopRequireDefault(_pallavi);
	
	var _SanjeevKrishnan = __webpack_require__(103);
	
	var _SanjeevKrishnan2 = _interopRequireDefault(_SanjeevKrishnan);
	
	var _ShwetaJalan = __webpack_require__(104);
	
	var _ShwetaJalan2 = _interopRequireDefault(_ShwetaJalan);
	
	var _VivekGambhir = __webpack_require__(149);
	
	var _VivekGambhir2 = _interopRequireDefault(_VivekGambhir);
	
	var _Harsh = __webpack_require__(78);
	
	var _Harsh2 = _interopRequireDefault(_Harsh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var icon18 = "https://www.winpeforum.com/assets/elements/MatangiGowrishankar.png";
	var icon19 = "https://www.winpeforum.com/assets/elements/RoshiniBakshi.jpg";
	var icon20 = "https://www.winpeforum.com/assets/elements/VineetRai.png";
	var icon21 = "https://www.winpeforum.com/assets/elements/KanwaljitSingh.png";
	var icon22 = "https://www.winpeforum.com/assets/elements/ShirishGodbole.png";
	var icon23 = "https://www.winpeforum.com/assets/elements/VaibhavGupta.png";
	var icon24 = "https://www.winpeforum.com/assets/elements/SheebuDavid.png";
	
	var icon25 = "https://www.winpeforum.com/assets/elements/Ashley-Menezes-1.jpg";
	var icon26 = "https://www.winpeforum.com/assets/elements/Bala_c_p.png";
	var icon27 = "https://www.winpeforum.com/assets/elements/RenukaRam.png";
	var icon28 = "https://www.winpeforum.com/assets/elements/Pallavi.png";
	var icon29 = "https://www.winpeforum.com/assets/elements/ShivaniBhasin.png";
	var icon30 = "https://www.winpeforum.com/assets/elements/VTBharadwaj.png";
	
	var mentors_constants = [{
		imgUrl: icon25,
		into: "Mr. Menezes is the COO and a Partner at ChrysCapital and has been with the firm for 24 years.",
		desc: "Mr. Menezes is the COO and a Partner at ChrysCapital and has been with the firm for 24 years. He is a member of the advisory committee and is responsible for diligence, regulatory/industry relationships, legal, compliance and operations. Mr. Menezes is a private equity veteran and has served on the board of the Indian private equity association for almost eight years, and is the current vice-chairman. He has also served as a member of the CII National Committee of private equity and other industry bodies.<br/><br/>\n\n        Prior to ChrysCapital, Mr. Menezes was with KPMG, in its information technology and U.S. GAAP practices, where, among other things, he was involved in the ADR issues and NYSE/NASDAQ listings of several leading Indian companies. Mr. Menezes is a rank-holding Chartered Accountant and received a Bachelor\u2019s degree in commerce from Mumbai University.\n        \n        \n\t\t",
		name: "Ashley Menezes        ",
		post: "COO & Partner  ",
		cmp: "ChrysCapital Advisors LLP",
		link: "https://in.linkedin.com/in/ashley-menezes-8166b1171"
	
	}, {
		imgUrl: icon26,
		into: " ",
		desc: "Bala C Deshpande is the Founder Partner of MegaDelta Capital.  Of her 32 years of experience, Bala has over two decades of investing experience. She started her investing career as Director Investments in ICICI Venture in 2001 and in 2008 she joined NEA at a General Partner to set up and head their India Practice. She along with two partners co-founded MegaDelta Capital in 2018-19.  \n        <br/><br/>\n        MegaDelta Capital is a growth equity firm investing in Tech intensive and/or IP based businesses across consumer, healthcare, enterprise tech and disruptive services sectors. At MegaDelta, she is keen to back entrepreneurs who redefine markets, hack growth models to create lasting economic value. She is passionate about Technology and its far-reaching implications on markets, businesses and consumers and strongly believes that the next wave of large businesses will be created on the foundation of innovative Tech. \n        <br/><br/>\n        Over the years, she has held close to 40 Board positions in companies across a wide spectrum of industries. Her experience as a Board member is also variegated in terms of size and stage from young, high involvement companies to large listed companies. She has played an instrumental role in shaping many innovative businesses and entrepreneurial journeys.  These include the first Internet IPO: Naukri.com, first 24-hour news channel: AAJ TAK, first Payment Tech company, several marquee consumer companies like Firstcry.com and GOQii that have redefined the sector.\n        <br/><br/>\n        Prior to her investing experience, Bala has had deep operating experience with reputed multi-national firms such as ICI, Cadbury\u2019s and BestFoods. She is a Management Graduate from Jamnalal Bajaj and has a Master\u2019s degree in Economics. \n        \n        ",
		name: "Bala C Deshpande",
		post: "Founder Partner",
		cmp: "MegaDelta Capital        ",
		link: "https://in.linkedin.com/in/bala-deshpande"
	
	}, {
		imgUrl: _Harsh2.default,
		into: " ",
		desc: "Accomplished business leader with expertise in Emerging Markets investing, building highly profitable investment businesses from the scratch, and setting and growing up multiple investment platforms.\n        <br/><br/>\n\t\tSpotted trends early on and used this to build large investments through platform, in a manner that assets are well diversified to optimize returns.\n\t\t<br/><br/>\n\t\tEarly investor in Sustainability for 15 years, built platforms, and invested in global technology businesses. During his career he has worked on financial investments across products and industries; advised CEOs on businesses and financial strategy, and built teams.\n\t\t<br/><br/>\n\t\tKey career highlights include building IFC\u2019s renewable investing business, conceptualizing and building India\u2019s largest road platform and setting up CDPQ India business across public equity, private equity, infra and fixed income.\n\t\t<br/><br/>\n\t\tThrough these journeys he has gained rich experience in scaling up businesses, driving sustainability, and corporate governance. Leading large global projects in multi-country and cultural setting. Negotiating documents under international tax and corporate laws. Building value creation strategies, executing these and steering organizational change.",
		name: "Harsh Singhal",
		post: "Founding Partner",
		cmp: "Edhina Capital",
		link: "https://www.linkedin.com/in/harsh-singhal-8321844/?originalSubdomain=in"
	
	}, {
		imgUrl: icon21,
		into: "Kanwal has always been passionate about mentoring and helping build consumer brands in India",
		desc: "Kanwal has always been passionate about mentoring and helping build consumer brands in India, and has been involved as an investor with brands like Paper Boat, ID Fresh, Epigamia, and Licious, before starting Fireside. He has been investing in the early stage ecosystem in India for the past 17 years, first as a Director at Carlyle Group, India, and later as a Co-Founder and Senior Managing Director of Helion Venture Partners. Prior to his investing career, Kanwal spent over 13 years in consumer marketing with Hindustan Unilever, and Intel India.\n\t\t",
		name: "Kanwaljit Singh",
		post: "Managing Partner",
		cmp: "Fireside Ventures",
		link: "https://in.linkedin.com/in/singhkanwaljit"
	}, {
		imgUrl: icon28,
		into: "Pallavi is a Partner in the International Capital Markets practice and is also the Joint Chair of Allen & Overy's India Group",
		desc: "Pallavi is a Partner in the International Capital Markets practice and is also the Joint Chair of Allen & Overy's India Group. Pallavi\u2019s practice focuses on debt and equity capital markets transactions in India and across the Asia Pacific region where she has over 18 years of experience advising issuers, underwriters and sponsors on Rule 144A and Regulation S international debt offerings, equity-linked offerings of exchangeable and convertible bonds, and equity offerings.<br/><br/>\n \n\t\tPallavi also has significant experience in bond restructurings, consent solicitations, exchange offers, induced conversions and tender offers. Many of the transactions she has advised on have been complex, innovative and award-winning.<br/><br/>\n\t\t \n\t\tPallavi is qualified as a solicitor in India, England and Wales and Singapore.<br/><br/>\n\t\t \n\t\tPallavi is consistently ranked in leading benchmarking publications. She is ranked as a highly regarded practitioner in IFLR1000 2019 and listed in the top 100 India-focused legal experts outside the country by India Business Law Journal. Clients say \u201CPallavi is considered a debt specialist, and well known for her focus on the Indian market.\u201D Chambers Asia Pacific describes her as \u201Cmeticulous and detail-oriented, has excellent legal skills and an ability to work well with Indian clients and Indian lawyers and a great deal lawyer and an asset to the team.\u201D Asia Pacific Legal 500 states that Pallavi is \u201Cextremely strong on knowledge, professionalism and accessibility\u201D and is \u201Cbusiness-friendly and willing to work at solving problems\u201D.\n\t\t",
		name: "Pallavi Gopinath Aney",
		post: "Partner",
		cmp: "Allen & Overy",
		link: "https://www.linkedin.com/in/pallavi-gopinath-aney-5922292/"
	
	}, {
		imgUrl: icon27,
		into: "Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn.",
		desc: "Renuka Ramnath is the Founder, Managing Director and CEO of Multiples Alternate Asset Management, a private equity manager and advisor to funds of ~ USD 1.5 bn. She has over 30 years of experience in the Indian financial sector across private equity, investment banking and structured finance. \n        <br/><Br/>\n\t\tFor close to three decades in financial services, Renuka successfully built several businesses in the ICICI Group including Investment Banking, e-commerce and private equity. As the MD & CEO of ICICI Venture for close to a decade, she led that firm to become one of the largest private equity funds in India. \n\t\t<br/><br/>\n\t\tShe is a Board member of EMPEA, the global industry association for private capital in emerging markets. She is also the Chairperson of the Executive Committee of Indian Venture Capital Association. Renuka has been featured in many prestigious listings, including the Top 25 Most Powerful Women in Business (Business Today, India); India's most Powerful CEO's (Economic Times), the Top 25 Non Bank Women in Finance (US Banker's global list), Asia's Women in the Mix: The Year's Top 50 for Achievement in Business (Forbes), Top 25 women in Asian asset management (Asian Investor) and most recently has been awarded the AVCJ Special Achievement Award, 2019.\n\t\t\n\t\t\n\t\t",
		name: "Renuka Ramnath",
		post: "Founder, MD & CEO",
		cmp: "Multiples Alternate Asset Management",
		link: "https://in.linkedin.com/in/renukaramnath"
	}, {
		imgUrl: icon19,
		into: " ",
		desc: "Roshini is a Managing Director, Private Equity at Everstone Capital Asia Pte based out of Singapore. Her role includes driving value creation in investee companies across all verticals in the areas of high-performance teams and human capital management, brand transformation and ESG including Impact.\n\t\t<br/><br/>\n\t\tRoshini serves on the boards of 3 public listed companies \u2013Persistent Systems Ltd (https://www.persistent.com/) ,JM Financial (https://jmfl.com/) and Restaurant Brands Asia Ltd . She was earlier on the board of Max Healthcare, the largest hospital network in India. In addition to this, she serves on the board of Everlife Pte Ltd, a Singapore company.\n\t\t<br/><br/>\n\t\tRoshini has more than 30 years of general management and marketing experience and strong track record in consumer industries, setting strategy and improving operational effectiveness to deliver greater financial returns.\n\t\t<br/><br/>\n\t\tPrior to Everstone, she was the CEO and Managing Director for the Walt Disney Company\u2019s Consumer, media and retail business for South Asia, where she set up and grew the business to more than $400 million in revenue. Some of her earlier roles were with Unilever, American Express, Mattel, and Polaris\n\t\t<br/><br/>\n\t\tShe believes very strongly in entrepreneurship as the future for innovation and growth and works pro bono with Endeavor.org as their global ambassador and panelist helping shortlist the next generation of growth businesses from emerging markets across the world. She also supports Enterprise Singapore, A Govt of Singapore enterprise as a mentor to some of the tech and consumer startups based in Singapore. In addition to this,Roshini is the co-chair of the DEI committee at the Singapore Venture Capital Association and a member of Singapore Institute of Directors.\n\t\t<br/><br/>\n\t\tRoshini holds an MBA from the Indian Institute of Management (Ahmedabad, India) and an undergraduate degree from St Stephens College (Delhi, India) majoring in Economics (Hons)\n\t\t<br/><br/>\n\t\tShe is a keen marathoner and passionate about running, and loves exploring new places during her runs.\n\t\t\n\t\t",
		name: "Roshini Bakshi",
		post: "Managing Director",
		cmp: "Private Equity, Everstone Capital Asia",
	
		link: "https://sg.linkedin.com/in/roshini-bakshi-2841702"
	}, {
		imgUrl: _SanjeevKrishnan2.default,
		into: " ",
		desc: "<div>Sanjeev Krishan is the Chairperson of PwC in India. Having been with the firm for over 31 years, Sanjeev has served in diverse leadership and client service roles. He has extensive experience working across sectors, both in India and overseas.\n\t\t<br/><br/>\n\t\tPrior to his current role, Sanjeev served as the Deals Leader for PwC India. He has successfully led the firm\u2019s Transactions, Private Equity and Deals businesses over the years - spearheading relationships with most global investors and getting the firm to a pre-eminent position amongst its private equity clients and their investee companies. Sanjeev also did a brief stint with PwC Sweden as part of an International Exchange programme, where he worked with several private equity funds and corporate clients, mostly on cross-border deals.\n\t\t<br/><br/>\n\t\tSanjeev is a part of FICCI\u2019s National Committee on Stressed Assets and is also a member of select CII sub-groups \u2013 deliberating new ideas and providing insights on important areas including board governance and related party transactions. Sanjeev is also a member of the SEBI Primary Market Advisory Committee, sharing his inputs on regulatory issues and legal frameworks to enable ease of doing business and drive investor interest in India. Additionally, he is a member of the Rotary Club of Delhi, South. \n\t\tHe frequently interacts with the media on various issues ranging from geopolitics, economic outlook for India, sectoral trends and other topics that are top-of-mind for Indian and global CEOs. Additionally, he regularly participates in seminars, panel discussions and events held globally including across India. \n\t\t<br/><br/>\n\t\tSanjeev is passionate about playing a part in building a sustainable future for the society we live in, and actively advocates the causes of conservation, socio-economic inclusion, and diversity. He is a certified Chartered Accountant, and an Associate Member of the Institute of Chartered Accountants of India (ICAI). Sanjeev graduated with First Class in Economics from the University of Delhi and remains an active and proud alum.\n\t\t<br/><br/>\n\t\tA nature lover, Sanjeev enjoys his morning walks and exercise regimen. He is also a cricket enthusiast and enjoys playing squash. As someone who strongly believes in continuous learning, Sanjeev is an avid reader and enjoys listening to podcasts covering a host of topics.\n\t\t\n       </div>",
		name: "Sanjeev Krishan",
		post: "Chairman",
		cmp: "PwC India",
		link: "https://in.linkedin.com/in/sanjeev-krishan"
	
	}, {
		imgUrl: icon29,
		into: "Shivani Bhasin Sachdeva",
		desc: " Shivani Bhasin Sachdeva is the Founder and Chief Executive Officer at India Alternatives. Shivani has over 15 years of private equity experience in the USA and in India at top notch private equity funds including IDFC Private Equity, Lightyear Capital and GE Equity where she has been responsible for deal sourcing, execution and monitoring companies across various sectors. Shivani has helped shape strategy at various companies through board level involvement and been instrumental in generating superior returns for her investors. Shivani is an MBA from Wharton and a BA from Mount Holyoke College (Massachusetts).\n\n\t\t",
		name: "Shivani Bhasin Sachdeva",
		post: " Founder & CEO",
		cmp: "India Alternatives",
		link: "https://in.linkedin.com/in/shivani-bhasin-sachdeva-47234757"
	
	}, {
		imgUrl: _Soumya_Rajan_new2.default,
		into: "As the founder of Waterfield Advisors, Soumya brings over 25 years of financial",
		desc: "Soumya is the founder and CEO of Waterfield Advisors, which is the largest multi-family office and wealth advisory firm in India. With over 25 years of experience in private banking and wealth advisory, Soumya commenced her career at ANZ Grindlays Bank, which later became Standard Chartered Bank. She worked for 17 years with the Bank in both India and Singapore, with her last role being the head of the Private Banking division of Standard Chartered in India. In 2011, she established Waterfield Advisors.\n\t\t<br/><br/>\n\t\tAs one of the earliest advocates of fee-only investment advisory in India, Soumya founded Waterfield on the principles of an alignment of interests with clients in the wealth advisory space. Today, Waterfield advises on financial assets exceeding $4 billion on behalf of India's leading and some of the most iconic business families. She also provides guidance to these families on non-investment issues such as succession planning, corporate and family governance, business strategy, and philanthropy. Soumya's leadership has contributed to Waterfield's reputation as one of India's largest and most-awarded wealth management firms.\n\t\t<br/><br/>\n\t\tIn recognition of her contributions to the wealth management industry and as an entrepreneur, Soumya has received several awards and honours. She was awarded Woman Entrepreneur of the Year (Finance Category) by Financial Express in 2023, listed in Forbes India's Most Powerful Women\u2019s List in 2021, won the Private Banker International's Outstanding Private Banker (Asia Pacific) award in 2021 and served on the global jury of the Euromoney Global Private Banking Awards in 2023.\n\t\t<br/><br/>\n\t\tSoumya is a member of the Advisory Committee of BASL, the regulatory and supervisory body for Registered Investment Advisors (RIAs) in India and serves as a Board member of several non-profit organizations in the education and healthcare sectors. She was awarded the Radhakrishnan Scholarship to study at Oxford University, UK, where she earned her Masters in Mathematics, in addition to holding a B.A (Hons) in Mathematics from St. Stephen's College, Delhi.\n\t\t\n\t\t\n\t\t",
		name: "Soumya Rajan",
		post: "Founder & CEO",
		cmp: "Waterfield Advisors",
		link: "https://in.linkedin.com/in/soumya-rajan-124b9b66"
	}, {
		imgUrl: icon20,
		into: "Vineet Rai is the Founder of Aavishkaar Group and chairs its Board and Group Executive Council",
		desc: "Vineet Rai is the Founder of Aavishkaar Group and chairs its Board and Group Executive Council. Aavishkaar Group is an Impact Investment Platform impacting millions of people in Asia and Africa using an entrepreneurship based development approach. Vineet believes in building impact ecosystems to deliver real Impact as enshrined in the vision of Aavishkaar Group \u201CWe exist to bridge the Opportunity gap for the Emerging 3 Billion\u201D. Vineet believes that Impact Investing has the potential to change the world of finance irreversibly.\n\t\t<br/><br/>\n\t\tThe Group\u2019s ecosystems include Aavishkaar Capital \u2013 the Impact fund manager focused on Global South, Arohan \u2013 One of India\u2019s largest & most digitally advanced microfinance institution (MFI) targeting low income households, Ashv Finance \u2013 a Fin Tech NBFC, offering unique cash flow based business loans to Micro, Small & Medium Enterprises and IntelleCap \u2013building Impact Ecosystems globally.\n\t\t<br/><br/>\n\t\tAavishkaar Group has 8000 employees, manages assets in excess of US $ 1.2 Billion while trying to serve needs of entrepreneurs from debt of US $ 150 (INR 10 thousands) to equity of US $ 15 Million (INR 100 Crore) while aligning the group to 13 out of the 17 Sustainable Development Goals or SDG\u2019s.\n\t\t<br/><br/>\n\t\tVineet has received numerous awards including the 2021 Access-HSBC Inclusive Finance India Award for personal contribution to Financial Inclusion in India, TIE Hall of Fame 2018, the Impact Investor of the Year by News Corp for 2016, Porter Prize for Strategic Leadership in Social Space, 2016, CNBC TV 18 Award for being the Catalyst Fund for India 2016, G 20 \u2013 SME Innovation in Finance Award 2010 in Seoul South Korea, UNDP-IBLF \u2013ICC World Business Award in 2005 and Lemelson Award for Social Venture Investing. In 2021 Vineet Rai and Swati Rai (Co-Founder) was awarded the Faces of Vibrant Bharat 2021 by Grant Thorton Bharat. He is an Ashoka Fellow and Honorary Member of XLRI Alumni Association. \n\t\t<br/><br/>\n\t\tIn 2022, Vineet has been appointed on the G20 Start up 20 Engagement Group Task Force on Sustainability and Securities and Exchange Board of India has appointed him on Advisory Committee of the Social Stock Exchange. Vineet was invited by the Hon\u2019ble Prime Minister Shri Narendra Modi for his \u201CRoundtable interaction with Venture Capital and Private Equity Funds\u201D. In 2021. Vineet was also invited by the Prime Minister Shri Narendra Modi for consultations on doubling the income of the farmers in September 2017 as part of his champions of change program. Vineet has also served on the advisory committee of SEBI for the formation of Social Stock Exchange, as Commissioner at the Business Commission for Sustainable Development, as Senior Advisor to Blended Finance Working Group at OECD and as an Advisor to United Nations Economic and Social Commission for Asia and the Pacific Science Technology and Innovation Advisory Board\n\t\t<br/><br/>\n\t\tVineet featured on the cover of Forbes India, January 2018 issue. Paul Polman, CEO of Unilever endorsed Aavishkaar Intellecap Group for its efforts in furthering inclusive development. \n\t\t<br/><br/>\n\t\tDriving on Indian roads is one of his passions and he tries to cover 50,000 KM every year.\n\t\t\n\t\t\n\t\t\n\t\t\n\t\t",
		name: "Vineet Rai",
		post: "Founder ",
		cmp: "Aavishkaar Group",
		link: "https://in.linkedin.com/in/vineet-rai-536160"
	}, {
		imgUrl: icon30,
		into: "VT Bharadwaj is a co-founder and General Partner at A91 Partners",
		desc: "VT Bharadwaj is a General Partner at A91 Partners, an Indian private investment firm that seeks to partner with founders to build enduring businesses for tomorrow\u2019s India.<br/><br/>\n \n\t\tPrior to co-founding A91 Partners, VT was a Managing Director at Sequoia Capital, a global venture capital firm in India where he led investments in consumer, pharmaceutical and healthcare sectors. Prior to that he worked at McKinsey & Co.<br/><br/>\n\t\t \n\t\tVT has an MBA from Indian Institute of Management Ahmedabad and a BE (Hons) in Electrical and Electronics Engineering from BITS Pilani\n\t\t<br/><br/>\n\t\tVT is a trustee at Ashoka University, a board member of IIM Ahmedabad Endowment Management Company, a Founding Circle member of Museum of Art & Photography and involved with Cuddles Foundation and Swasth Foundation.\n\t\t",
		name: "VT Bharadwaj",
		post: "Co-founder and General Partner",
		cmp: "A91 Partners",
		link: "https://in.linkedin.com/in/vt-bharadwaj-2333ba1"
	}];
	
	exports.default = mentors_constants;
	module.exports = exports["default"];

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Mentors = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(570);
	
	var _Modal = __webpack_require__(21);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentors = __webpack_require__(402);
	
	var _mentors2 = _interopRequireDefault(_mentors);
	
	var _knowledgeCenter = __webpack_require__(44);
	
	var _knowledgeCenter2 = _interopRequireDefault(_knowledgeCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
		var activeItem = _ref.activeItem,
		    show = _ref.show,
		    onHide = _ref.onHide;
	
		return _react2.default.createElement(
			_Modal2.default,
			{ direction: '', className: 'teamdetails__wrapper', show: show, onHide: onHide },
			_react2.default.createElement(
				_Modal2.default.Header,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'head_section' },
					_react2.default.createElement(
						'span',
						{ className: 'item_name' },
						activeItem.name
					),
					_react2.default.createElement(
						'div',
						{ className: 'item_des' },
						activeItem.post
					),
					_react2.default.createElement(
						'div',
						{ className: 'item_des' },
						activeItem.cmp
					)
				),
				_react2.default.createElement(
					'span',
					{ className: 'cross pull-right' },
					_react2.default.createElement('i', { onClick: onHide, className: 'fa fa-times' })
				)
			),
			_react2.default.createElement(
				_Modal2.default.Body,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'item__desc' },
					_react2.default.createElement('div', { className: 'item__desc_scr', style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
				)
			),
			_react2.default.createElement(_Modal2.default.Footer, null)
		);
	};
	
	TeamModal.propTypes = {
		activeItem: _propTypes2.default.object,
		show: _propTypes2.default.object,
		onHide: _propTypes2.default.object
	};
	
	var Mentors = exports.Mentors = function (_React$Component) {
		_inherits(Mentors, _React$Component);
	
		function Mentors(args) {
			_classCallCheck(this, Mentors);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.togglePopUp = function (item) {
				_this.setState({
					isShow: !_this.state.isShow,
					activeItem: item || {}
				});
			};
	
			_this.state = {
				activeItem: {},
				isShow: false
			};
			return _this;
		}
	
		Mentors.prototype.render = function render() {
			var _this2 = this;
	
			var location = this.props.location;
			var isShow = this.state.isShow;
	
			return _react2.default.createElement(
				_contentPage2.default,
				null,
				_react2.default.createElement(_meta2.default, { title: 'Winpe ProClub Mentorship Program | Mentors', description: 'Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.', image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
				_react2.default.createElement(
					'div',
					{ className: 'mentors-wrapper' },
					_react2.default.createElement(
						'section',
						{ id: 'team', className: 'pb-5' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'h1',
								{ className: 'section-title h1' },
								'Mentors',
								_react2.default.createElement('br', null),
								'Cohort IV'
							),
							_react2.default.createElement(
								'div',
								{ className: 'section_intro_text' },
								'Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_mentors2.default.map(function (item, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-sm-6 col-md-4' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'mainflip flip-0', style: { minHeight: '450px' } },
												_react2.default.createElement(
													'div',
													{ className: 'frontside' },
													_react2.default.createElement(
														'div',
														{ className: 'card' },
														_react2.default.createElement(
															'div',
															{ className: 'card-body text-center mt-4' },
															_react2.default.createElement(
																'p',
																null,
																_react2.default.createElement('img', { onClick: function onClick() {
																		return _this2.togglePopUp(item);
																	}, className: ' img-fluid', src: item.imgUrl, alt: item.name })
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_title' },
																item.name
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text1' },
																item.post
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text1' },
																item.cmp
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text', style: { height: 'auto' } },
																item.cohort
															),
															_react2.default.createElement(
																'a',
																{ target: '_blank', href: item.link, className: 'btn btn-primary btn-sm' },
																_react2.default.createElement('i', { className: 'fa fa-linkedin' })
															)
														)
													)
												)
											)
										)
									);
								}),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 col-sm-6 col-md-4' },
									_react2.default.createElement(
										'div',
										{ className: '' },
										_react2.default.createElement(
											'div',
											{ className: 'mainflip flip-0' },
											_react2.default.createElement(
												'div',
												{ className: 'frontside' },
												_react2.default.createElement(
													'div',
													{ className: 'card' },
													_react2.default.createElement(
														'div',
														{ className: 'card-body text-center mt-4' },
														'\xA0'
													)
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
					)
				)
			);
		};
	
		return Mentors;
	}(_react2.default.Component);
	
	Mentors.propTypes = {
		location: _propTypes2.default.object
	};
	
	exports.default = Mentors;

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cohort-iv-mentors-index-jsx-112e7798d16ddc49664d.js